import React from 'react';

function About(props) {
    return (
        <div className="p-5 mt-5" id="about" >
            <header className="text-center">
                <h1>About Us</h1>
            </header>
            <main>
                <p className="text-dark fst-normal lh-lg">
                <span className="fw-bold">EDUGEN TECHNICAL INSTITUTE (ETI)</span> is an engineering training institute that focuses on delivering the following technical training programs:
                    <ul>
                        <li>Solar installation and maintenance services training</li>
                        <li>Household wiring and maintenance training</li> 
                        <li>Mobile and computer repair and refurbishing training</li>
                        <li>CCTV installation and maintenance services training</li>
                        <li>Modern Software installation and fabrication training</li>
                    </ul>
                </p>
                <p className="text-dark fst-normal lh-lg">
                ETI was established during in-depth research into the modern-day technological ecosystem and its rise and fall in Nigeria and Africa at large, and the need for technical expertise in the system. <br/>
                Hence, ETI put together a team of experts in different aspects in engineering and other technically aware fields to assist individuals with the desire to improve their technological skills, with or without prior knowledge of any kind. <br/>
                ETI considers this as a form of contribution to the growth of technical expertise in Nigeria and Africa at large. Below is a display of some of our experts and their various field.
                </p>
            </main>
        </div>
    );
}

export default About;